export default class {
    constructor(){
        const callback = (entries) => {
            entries.forEach( (entry) => {
                
                if (entry.isIntersecting) {
                    visible(entry.target);
                }
            });
        }
        const observerOptions = {
            rootMargin: "0px 0px -20% 0px",
            threshold: 0
        }
        this.observer = new IntersectionObserver(callback, observerOptions)
        const sections = document.querySelectorAll('[data-scroll-trigger]')
        if( sections.length > 0 ){
            sections.forEach( el => { 
                this.observer.observe(el)
            })
        }

        
        const visible = (t) => {
            const triggerType = t.getAttribute('data-scroll-trigger')
            if(!t.classList.contains('in-view')){

                if(triggerType == 'translateY'){
                    const strs = t.querySelectorAll('.str__animation');

                    anime({
                        targets: strs,
                        translateY:['100%',0],
                        easing: 'easeInOutSine',
                        duration: 800,
                        delay: function(el, i) { return i * 20 },
                        complete :()=>{
                            t.classList.add('in-view')
                        }
                    });
                }else{
                    t.classList.add('in-view')
                }
            }
  
        }
    }
}